import { formatNumber } from '../../../lib/script'
import classes from './DashboardItem.module.css'
import { useSelector } from 'react-redux'

export default function WidgetSummary({perPage, widgetType}) {
    const list = useSelector(state => state[`${widgetType}`].dashboardList)
    // const list = null

    return <div className={classes.description}>
        <span className={classes.description_latest}>Last {perPage} entries</span> {list && list.meta && list.meta.total > perPage && <>{formatNumber(list.meta.total)} total cases</>}
    </div>
}